import { Injectable } from '@angular/core';
import { gql, Subscription } from 'apollo-angular';

const APPLICATION_SUPPLEMENTAL_FORM_SUBSCRIPTION = gql`
  subscription supplementalFormChanges($applicationId: String) {
    onApplicationSupplementalFormEvent(
      input: { applicationId: $applicationId }
    ) {
      data {
        applicationId
        initiatingUserId
        supplementalFormStatusId
        supplementalFormVersionNumber
      }
    }
  }
`;

@Injectable({
  providedIn: 'root',
})
export class ApplicationSupplementalFormSubscriptionService extends Subscription {
  document = APPLICATION_SUPPLEMENTAL_FORM_SUBSCRIPTION;
}
